import angular from 'angular';

import MenuCtrl from './MenuCtrl';

const menuModule = angular.module('sling.menu', []);

menuModule.controller('MenuCtrl', MenuCtrl);

export default menuModule.name;
